import React from 'react'

import routes from '../config/settings/routes'
import BrandLayout from '../components/Layouts/BrandLayout'
import DownloadsLayout from '../components/Layouts/DownloadsLayout'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import { DownloadsNavProvider } from '../components/Navigation/DownloadsNavButton.context'
import CantFindDataFormContainer from '../containers/CantFindDataForm/CantFindDataForm.container'
import DownloadCfmpSectionContainer from '../containers/DownloadCfmpSection/DownloadCfmpSection.container'
import FooterContainer from '../containers/Footer/Footer.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'
import NotFoundPage from './NotFound'

/**
 * The DownloadCfmp page.
 */
const DownloadCfmpPage = () => (
  <ProtectByFeatures
    fallback={() => <NotFoundPage />}
    rule={features => features['cl.chilecompra.datos-abiertos/downloads-page']}
  >
    <BrandLayout footer={<FooterContainer margin="0" />}>
      <TopNavbarContainer menuActive={routes.downloads} />
      <SearchBuyerPanelContainer />

      <DownloadsNavProvider>
        <DownloadsLayout menuActive={routes.downloadCfmp}>
          <DownloadCfmpSectionContainer />
        </DownloadsLayout>
      </DownloadsNavProvider>

      <CantFindDataFormContainer />
    </BrandLayout>
  </ProtectByFeatures>
)

export default DownloadCfmpPage
